export default __webpack_public_path__ + "static/media/8.4e8c6cb0.webp";